export const CardDimensions = {
    height: {
        Regular: "400px",
        Short: "300px"
    },
    width: {
        samsungGalaxyS9: "360px"
    }
}